import React, { useEffect, useState } from 'react';
import { Typography, List, ListItem, ListItemText, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Hadith = () => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://www.hadithapi.com/api/books?apiKey=$2y$10$egscBWNnrSTXADABLpzeBu796XG0evVc30trp9DpeWoseA0Pa');
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        // Using the provided links for the first 8 books
        const providedLinks = [
          'https://sunnah.com/bukhari',
          'https://sunnah.com/muslim',
          'https://sunnah.com/tirmidhi',
          'https://sunnah.com/abudawud',
          'https://sunnah.com/ibnmajah',
          'https://sunnah.com/nasai',
          'https://sunnah.com/mishkat',
          'https://sunnah.com/ahmad',
        ];
        const booksWithLinks = data.books.slice(0, providedLinks.length).map((book, index) => ({
          ...book,
          externalLink: providedLinks[index],
        }));
        setBooks(booksWithLinks);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleButtonClick = (book) => {
    window.open(book.externalLink, '_blank');
  };

  return (
    <div style={{ color: 'gold', borderRadius:'3px',  backgroundColor: 'darkslategray', padding: '20px', margin: '0 10px', minHeight: '100vh', marginTop:'10px' }}>
      <Typography variant="h3" gutterBottom sx={{fontFamily:'Cinzel Decorative'}}>
        Hadith Books
      </Typography>
      <List>
        {books.map((book) => (
          <Accordion key={book.id} style={{ backgroundColor: 'black', marginBottom: '10px' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: 'gold' }} />}
              aria-controls={`book-${book.id}-content`}
              id={`book-${book.id}-header`}
            >
              <Typography style={{fontFamily:'Cinzel Decorative' , color:'gold'}} variant="h5">{book.bookName}</Typography>
            </AccordionSummary><hr/>
            <AccordionDetails>
              <List sx={{color:'gold'}}>
                <ListItem>
                  <ListItemText sx={{fontStyle:'italic',fontWeight:'lighter'}} primary={`WRITER: ${book.writerName}`} />
                </ListItem><hr/>
                <ListItem>
                  <ListItemText sx={{fontStyle:'italic',fontWeight:'lighter'}} primary={`ABOUT WRITER: ${book.aboutWriter || 'N/A'}`} />
                </ListItem><hr/>
                <ListItem>
                  <ListItemText sx={{fontStyle:'italic',fontWeight:'lighter'}} primary={`WRITER DEATH: ${book.writerDeath}`} />
                </ListItem><hr/>
                <ListItem>
                  <ListItemText sx={{fontStyle:'italic',fontWeight:'lighter'}} primary={`HADITHS COUNT: ${book.hadiths_count}`} />
                </ListItem><hr/>
                <ListItem>
                  <ListItemText sx={{fontStyle:'italic',fontWeight:'lighter'}} primary={`CHAPTERS COUNT: ${book.chapters_count}`} />
                </ListItem><hr/>
                {/* Button for External Link */}
                <Button onClick={() => handleButtonClick(book)} sx={{backgroundColor:'goldenrod',color:'black'}} variant="contained" >
                  Click for more details
                </Button>
              </List>
            </AccordionDetails>
          </Accordion>
        ))}
      </List>
    </div>
  );
};

export default Hadith;
